import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '..';
import { formatStringsToPlural } from '../../utils';

import { handleClosePopUp } from '../../utils/genericHandles';

interface IChildrenAgeSelectProps {
  id: string;
  value: number;
  onSelect: (age: number, selectIndex: number) => void;
}

const ChildrenAgeSelect = ({ id, value, onSelect, ...props }: IChildrenAgeSelectProps) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const ref = useRef<HTMLElement>(null);

  const CHILDREN_AGE = [...Array(18).keys()];

  useEffect(() => handleClosePopUp(ref, () => setIsOpen(false)), []);

  useEffect(() => {
    const component = document.querySelector(`#${id}`) as HTMLDivElement;
    const input = component.querySelector('.children-age-select-input') as HTMLButtonElement;
    const menu = component.querySelector('.children-age-select-menu') as HTMLDivElement;
    const { x, width } = menu.getBoundingClientRect();

    if (isOpen) {
      input.classList.add('open');
      menu.classList.add('open');

      if (x + width > window.innerWidth) {
        menu.classList.add('right');
      }
    } else {
      input.classList.remove('open');
      menu.classList.remove('open');
    }
  }, [id, isOpen]);

  const handleToggle = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setIsOpen((prevState) => !prevState);
  };

  const handleSelect = (event: React.MouseEvent<HTMLSpanElement>) => {
    const optionLiElement = (event.target as Element).parentElement as HTMLLIElement;

    const age = optionLiElement.value;
    const selectId = id.split('-');
    const selectIndex = parseInt(selectId[selectId.length - 1], 10) - 1;

    setIsOpen(false);
    onSelect(age, selectIndex);
  };

  return (
    <section className="children-age-select-container" ref={ref} id={id} {...props}>
      <button className="children-age-select-input" type="button" onClick={handleToggle}>
        <span className="children-age-select-input-text">{value}</span>
        <Icon className="children-age-select-input-icon" icon="arrow_drop_down" round />
      </button>

      <ul className="children-age-select-menu">
        {CHILDREN_AGE.map((age) => (
          <li key={`children-age-select-menu-option-${age + 1}`} value={age}>
            <span className="children-age-select-menu-option" onClick={handleSelect}>
              {t('counterInput.roomInput.counter.childrenAgeOption', { age: formatStringsToPlural('ano', age) })}
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default ChildrenAgeSelect;
